<div class="order-summary-header">
    <div class="order-summary-header-inner">
        <div class="header-left">
            <div class="page-name">{{ title }}</div>
        </div>
        <div class="header-right">
            <div class="header-right-order">Order ID</div>
            <div class="header-right-number">#{{ orderId || "" }}</div>
        </div>
    </div>
</div>

<!-- Modal - Used for both "already booked" and error messages -->
<div class="modal fade" id="orderSummaryModal">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-body">
                <span *ngIf="!showError">
                    This order has already been signed. You have been redirected to
                    the confirmation page.
                </span>
                <span *ngIf="showError" [style.color]="'red'">
                    {{ errorMessage }}
                </span>
            </div>
            <div class="modal-footer">
                <button
                    type="button"
                    class="modal-close-btn"
                    (click)="closeModal()"
                >
                    Close
                </button>
            </div>
        </div>
    </div>
</div>

<!-- Main Content - Only show for newly booked orders -->
<div class="order-summary-main order-summary-main-top-header">
    <div class="text-center mt-5">
        <p class="mt-3">
            Thank you for placing the order. You can click on the button
            below to download the PDF summary.
        </p>
    </div>
</div>

<!-- Download Button -->
<div class="order-summary-main order-summary-main-bottom-header">
    <div class="order-summary-main-inner">
        <div class="order-summary-main-button-container mt-5 mb-5">
            <div class="order-summary-main-button">
                <button
                    type="button"
                    id="orderReportDownload"
                    class="download-button"
                    (click)="downloadPdf()"
                    [disabled]="isDownloading"
                >
                    <span>Download Order Summary</span>
                    <span>
                        <i
                            *ngIf="!isDownloading"
                            class="fa-solid fa-file-arrow-down icon-span"
                        ></i>
                        <div *ngIf="isDownloading" class="spinner">
                            <div class="dot"></div>
                            <div class="dot"></div>
                            <div class="dot"></div>
                        </div>
                    </span>
                </button>
            </div>
        </div>
    </div>
</div>
